







































import PoiButton from "./PoiButton.vue";
import iphonePois from "../data/iphone-pois";
import ipadPois from "../data/ipad-pois";
import watchPois from "../data/watch-pois";
export default {
  components: { PoiButton },
  props: {
    currentPoi: Object,
    pois: Object,
    contentEnabled: Boolean,
  },
  computed: {
    productViewIndex: function () {
      return this.productOrder.indexOf(this.currentPoi.id);
    },
  },
  data() {
    return {
      productPois: {
        ...iphonePois,
        ...watchPois,
        ...ipadPois,
      },
      productOrder: [
        "iphone12ProMax",
        "iphone12Pro",
        "iphone12",
        "iphone12Mini",
        "watch6",
        "watchSE",
        "ipadAir",
        "ipad",
      ],
    };
  },
  mounted: function () {},
  methods: {
    productLeft: function () {
      var target = this.productViewIndex - 1;
      if (target < 0) return;
      this.navigate(this.productOrder[target]);
    },
    productRight: function () {
      var target = this.productViewIndex + 1;
      if (target >= this.productOrder.length) return;
      this.navigate(this.productOrder[target]);
    },
    navigate: function (loc) {
      this.$root.playClick();
      this.$emit("setContentEnabled", false);
      if (loc == "products" || this.pois[loc].product == false) {
        //slow nav for non product transitions
        this.$emit("navigate", loc, false, 1200);
        return;
      }

      this.$emit("navigate", loc, false, 700);
    },
  },
};
